var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledVeteranBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 396,
    viewBox: "0 0 630 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3105_7711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614 0H16C7.16344 0 0 7.16344 0 16V396H630V16C630 7.16344 622.837 0 614 0Z",
    fill: "url(#paint0_radial_3105_7711)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.716 53.5763L163.83 8V265.34H207.716V53.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.822 53.5763L155.709 8V265.34H111.822V53.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5137 96.4847V240.49C70.5137 267.891 92.8937 293.373 120.256 293.373H198.463C225.825 293.373 248.205 267.891 248.205 240.49V95.6251L222.744 69.1758L223.832 245.111C223.832 275.49 202.525 281.783 176.466 281.783H141.179C115.12 281.783 94.5339 274.922 94.5339 245.111V71.5398L70.5137 96.4847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.929 128.579L280.159 244.892C280.159 284.189 248.06 316.334 208.819 316.334H108.798C69.5565 316.334 37.458 284.189 37.458 244.892L37.6266 129.93L56.5577 110.972V242.819C56.5577 276.591 84.1495 304.222 117.873 304.222H199.759C233.483 304.222 261.09 276.591 261.09 242.819V109.007L279.944 128.579H279.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 157.725V255.509C308 301.976 270.031 340 223.63 340H92.3697C45.9694 340 8 301.976 8 255.509L8.2146 161.164L27.7435 140.502V252.056C27.7435 293.395 61.5128 327.213 102.793 327.213H214.832C256.112 327.213 289.881 293.395 289.881 252.056L290.295 139.289L307.985 157.71L308 157.725Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_b_3105_7711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H614C622.837 0 630 7.16344 630 16V396H0V16Z",
    fill: "#0D318B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3105_7711",
    x: -60,
    y: -60,
    width: 750,
    height: 516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3105_7711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3105_7711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3105_7711",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(321.835 160.03) scale(542.654 241.179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B6BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0A66B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#064385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#03285E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#011442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#000831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00042B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3105_7711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 630,
    height: 396,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledVeteranBg);
export default __webpack_public_path__ + "static/media/DisabledVeteranBg.53a6fe548525d8215981f88540503826.svg";
export { ForwardRef as ReactComponent };